export class TipoEstadoAsignacionConstants {
  static EN_REVISION = 'En revision';
  static CON_OBSERVACIONES = 'Con observaciones';
  static APROBADO = 'Aprobado';
  static BAJA = 'Baja';
  static RECHAZADO = 'Rechazado';
}
